import React from 'react'

export const ModalCreateTaskAsync = React.lazy(() => import('./modal-create-task'))
